import LinkToDocusaurus from '@eggplant/embedded-documentation/src/lib/components/LinkToDocusaurus'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import type * as docsRoutes from '../../docs-routes'

interface Props {
  descriptionText: string
  withDocumentationLink?: typeof docsRoutes[keyof typeof docsRoutes] | ''
}

const RunSelectedStepsFilterDescription = ({
  descriptionText,
  withDocumentationLink = ''
}: Props) => (
  <Paragraph>
    <Color variant='theme-description-text'>
      {descriptionText}
    </Color>
    {
      withDocumentationLink &&
        <Paragraph>
          <LinkToDocusaurus path={withDocumentationLink}>Learn more in the DAI documentation</LinkToDocusaurus>
        </Paragraph>
    }
  </Paragraph>
)

export default RunSelectedStepsFilterDescription
